module.exports = __webpack_public_path__ + "static/media/pic1.44a6fc06.jpg";